// extracted by mini-css-extract-plugin
module.exports = {"contentTab":"Content_contentTab__3Tu0r","paidTabBar":"Content_paidTabBar__1orNa"};